import React, { createContext, useContext, useState } from "react";

const DashboardContext = createContext();

export const DashboardProvider = ({ children }) => {
  const [dashboardData, setDashboardData] = useState({
    teacherClasses: [],
    totalSubjects: 0,
    adminStats: {
      teacherCount: 0,
      studentCount: { male: 0, female: 0, total: 0 },
      classCount: 0,
      studentsByClass: [],
      sectionCount: 0,
      financialStats: { expected: 0, actual: 0, balance: 0 },
      financialStatsByClass: [],
    },
    parentData: {
      classes: [],
      kidsFinancials: [],
      totalKids: 0,
      totalFinancials: { expected: 0, actual: 0, balance: 0 },
    },
    lastFetched: null,
    currentTerm: null,
  });

  const [loading, setLoading] = useState(true);

  return (
    <DashboardContext.Provider
      value={{ dashboardData, setDashboardData, loading, setLoading }}
    >
      {children}
    </DashboardContext.Provider>
  );
};

export const useDashboard = () => useContext(DashboardContext);